/* eslint-disable */
import React, { useState } from "react";
import {
  Sparkles,
  Zap,
  HandHeart,
  CheckCircle,
} from "lucide-react";

import { useNavigate } from "react-router-dom";

import "./Website.scss";
import img1 from "../assets/images/img1.jpeg"
import img2 from "../assets/images/img2.jpeg"

import whatsappIcon from "../assets/images/whatsapp.svg";
import phoneIcon from "../assets/images/telephone.svg";
import instagramIcon from "../assets/images/instagram-svgrepo-com.svg";
import facebookIcon from "../assets/images/facebookIcon.svg";
import wazeIcon from "../assets/images/brand-waze.svg";



function Website() {
    const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", company: "", email: "", phone: "", message: "" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="website">
      {/* Header */}
{/* <header className="header">
  <div className="logo">
    <a href="/website"><img className="logo-img" src={logo} alt="logo"></img></a>
  </div>
  <nav className="nav">
    <a href="#about">About Us</a>
    <a href="#services">Services</a>
    <a href="#gallery">Gallery</a>
    <a href="#contact">Contact</a>
    <a href="/" className="cta">
      לתפריט
    </a>
  </nav>
</header>
 */}

      {/* Hero Section */}
      <section className="hero">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1>
            מאפים טריים ועוגות מיוחדות נוצרים באהבה
          </h1>
          <button onClick={() => navigate("/")} className="btn-main">לתפריט</button>
        </div>
      </section>

      {/* ABOUT US SECTION */}
<section id="about" className="about">
  <div className="container">
    <h2>אודות</h2>
    <p>
ברוכים הבאים לDeluxe! בית קפה בוטיק בכפר ראמה. אצלנו תמצאו קוראסונים, מאפים, עוגות ועוד הרבה.
    </p>
    <p>
פיסה קטנה לוקחת אתכם לעולם אחר. המאפים שלנו עשויים מחומרי גלם איכותיים, נאפים טריים במקום, ולאחר מכן מוגשים אליכם באהבה.
    </p>
      <p>
אנחנו חיים ונושמים מתוקים. וזו הסיבה שאנחנו כל הזמן מפתחים עבורכם יצירות חדשות, טעימות ומרגשות שמעולם לא טעמתם.
    </p>
  </div>
</section>


      <div className="image-wrapper">
        <img
          src={img2}
          alt="Banner"
          className="styled-img"
        />
      </div>


     {/*    
      <section className="intro">
        <h2>
          So How Do You Get The
          <br />
          Most Out Of Your Marketing?
        </h2>
      </section>

 
      <section id="services" className="solutions">
        <div className="card">
          <Users size={40} className="icon" />
          <h3>Do Everything Yourself?</h3>
          <p>
            If you have little to do, it’s fine. But if you’re busy, this just
            isn’t feasible.
          </p>
        </div>
        <div className="card">
          <Briefcase size={40} className="icon" />
          <h3>Hire New Staff?</h3>
          <p>
            Finding people is hard, training is costly. And even then, you rely
            on one person.
          </p>
        </div>
        <div className="card">
          <Target size={40} className="icon" />
          <h3>Hire An Agency?</h3>
          <p>
            Without a big budget, your account is often managed by an intern.
            Not ideal.
          </p>
        </div>
                <div className="card">
          <Target size={40} className="icon" />
          <h3>Hire An Agency?</h3>
          <p>
            Without a big budget, your account is often managed by an intern.
            Not ideal.
          </p>
        </div>
                <div className="card">
          <Target size={40} className="icon" />
          <h3>Hire An Agency?</h3>
          <p>
            Without a big budget, your account is often managed by an intern.
            Not ideal.
          </p>
        </div>
      </section> */}

      {/* What Sets Us Apart */}
      <section id="whyus" className="whyus">
        <h2>מה מייחד אותנו</h2>
        <div className="grid">
    <div className="card">
      <Sparkles size={40} className="icon" aria-hidden="true" />
      <h3>טריות</h3>
      <p>נאפים מדי יום עם חומרי הגלם הטובים ביותר – תמיד טרי.</p>
    </div>
    <div className="card">
      <CheckCircle size={40} className="icon" aria-hidden="true" />
      <h3>הנאה מובטחת</h3>
      <p>האושר שלכם הוא המתכון שלנו. כל ביס צריך להביא איתו חיוך.</p>
    </div>

    <div className="card">
      <Zap size={40} className="icon" aria-hidden="true" />
      <h3>משלוח עד הבית</h3>
      <p>כל הזמנה תגיע אליכם עד הבית.</p>
    </div>

    <div className="card">
      <HandHeart size={40} className="icon" aria-hidden="true" />
      <h3>אומנות ואהבה</h3>
      <p>כל יצירה נעשית בתשוקה, דיוק והרבה אהבה.</p>
    </div>

        </div>
      </section>

            {/* GALLERY SECTION */}
{/*         <section id="gallery" className="gallery">
        <div className="container">
            <h2>Our Gallery</h2>
            <p className="subtitle">
            A glimpse of our latest projects and creative work.
            </p>
            <div className="gallery-grid">
            <img src={c1t5} alt="Project 1" />
            <img src={c9t3}  alt="Project 2" />
            <img src={c1t1}  alt="Project 3" />
            <img src={c4t3}  alt="Project 4" />
            <img src={c7t2}  alt="Project 5" />
            <img src={c9t8}  alt="Project 6" />
            </div>
        </div>
        </section> */}

      <div className="image-wrapper">
        <img
          src={img1}
          alt="Banner"
          className="styled-img"
        />
      </div>


      {/* Contact Form */}
  <section id="contact" className="contact-section">
  <h2>צור קשר</h2>
  <p className="contact-subtitle">אנחנו זמינים בשבילכם בכל הערוצים 👇</p>

  <div className="contact-grid">
<a href="https://wa.me/972548993333" target="_blank" rel="noopener noreferrer" className="contact-card whatsapp">
  <img src={whatsappIcon} alt="WhatsApp" />
  <span>WhatsApp</span>
</a>

{/* <a href="tel:0548993333" className="contact-card phone">
  <img src={phoneIcon} alt="Phone" />
  <span>התקשרו אלינו</span>
</a> */}

<a href="https://www.instagram.com/deluxe._.patisserie/" target="_blank" rel="noopener noreferrer" className="contact-card instagram">
  <img src={instagramIcon} alt="Instagram" />
  <span>Instagram</span>
</a>

<a href="https://www.facebook.com/profile.php?id=100040296173784" target="_blank" rel="noopener noreferrer" className="contact-card facebook">
  <img src={facebookIcon} alt="Facebook" />
  <span>Facebook</span>
</a>

<a href="https://ul.waze.com/ul?venue_id=23200073.231869662.2068717" target="_blank" rel="noopener noreferrer" className="contact-card waze">
  <img src={wazeIcon} alt="Waze" />
  <span>Waze</span>
</a>

  </div>
</section>

      {/* Footer */}
{/* <footer className="footer">
  <div className="footer-content">
    <div className="footer-column">
      <h3>Contact Us</h3>
      <p>123 Marketing Street</p>
      <p>New York, NY 10001</p>
      <p>Phone: (555) 123-4567</p>
      <p>Email: contact@agency.com</p>
    </div>

    <div className="footer-column">
      <h3>Quick Links</h3>
      <ul>
        <li><a href="#services">Services</a></li>
        <li><a href="#about">About Us</a></li>
        <li><a href="#testimonials">Case Studies</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
    </div>

    <div className="footer-column">
      <h3>Legal</h3>
      <ul>
        <li><a href="#">Privacy Policy</a></li>
        <li><a href="#">Terms of Service</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom">
    <p>&copy; 2025 Don Carlos. All rights reserved.</p>
  </div>
</footer> */}
    </div>
  );
}

export default Website;
